import { render, staticRenderFns } from "./NewsHighlight.vue?vue&type=template&id=1bb3325f&"
import script from "./NewsHighlight.vue?vue&type=script&lang=js&"
export * from "./NewsHighlight.vue?vue&type=script&lang=js&"
import style0 from "./NewsHighlight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports